import type { ReactNode } from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

/**
 * TablePageLayout
 * Classification: custom (template)
 *
 * Standard list/table page: a header (title, description, primary actions), an
 * optional toolbar (search/filters) and a content region for the table.
 */
export interface TablePageLayoutProps {
  title: string;
  description?: string;
  /** Primary actions, right-aligned in the header. */
  actions?: ReactNode;
  /** Toolbar row above the table (search, filters, view toggles). */
  toolbar?: ReactNode;
  children: ReactNode;
}

export function TablePageLayout({
  title,
  description,
  actions,
  toolbar,
  children,
}: TablePageLayoutProps) {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
      <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 2 }}>
        <Box sx={{ flex: 1, minWidth: 0 }}>
          <Typography variant="h4" sx={{ fontFamily: 'inherit' }}>
            {title}
          </Typography>
          {description ? (
            <Typography variant="body1" color="text.secondary" sx={{ mt: 0.5 }}>
              {description}
            </Typography>
          ) : null}
        </Box>
        {actions ? <Box sx={{ display: 'flex', gap: 1 }}>{actions}</Box> : null}
      </Box>
      {toolbar ? (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, flexWrap: 'wrap' }}>{toolbar}</Box>
      ) : null}
      <Box sx={{ minWidth: 0 }}>{children}</Box>
    </Box>
  );
}
